"use client";

import { toast } from "sonner";
import { AlertCircle, CheckCircle, ExternalLink, File } from "lucide-react";
import type { UploadResults } from "./SaveAttachmentsToGoogleDriveModal.types";

interface SaveAttachmentsResultsProps {
  uploadResults: UploadResults;
}

export function SaveAttachmentsResults({ uploadResults }: SaveAttachmentsResultsProps) {
  return (
    <div className="space-y-4">
      {uploadResults.uploaded.length > 0 && (
        <div className="p-4 bg-green-50 dark:bg-green-950/40 border border-green-200 dark:border-green-800 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <CheckCircle className="h-5 w-5 text-green-600" />
            <h3 className="font-medium text-green-900 dark:text-green-200">
              Successfully Uploaded ({uploadResults.uploaded.length})
            </h3>
          </div>
          <div className="space-y-2">
            {uploadResults.uploaded.map((file, idx) => (
              <button type="button"
                key={idx}
                onClick={() => {
                  if (file.webViewLink) {
                    window.open(file.webViewLink, "_blank");
                  } else {
                    console.error("No webViewLink available:", file);
                    toast.error("Link not available");
                  }
                }}
                className="w-full flex items-center gap-2 p-3 rounded bg-white dark:bg-gray-900 border border-green-200 dark:border-green-800 hover:border-green-400 hover:bg-green-50 dark:hover:bg-green-950/40 transition-colors group cursor-pointer text-left"
              >
                <File className="h-4 w-4 text-green-600 flex-shrink-0" />
                <span className="text-sm font-medium text-green-700 dark:text-green-300 group-hover:text-green-900 flex-1 truncate">
                  {file.filename}
                </span>
                <ExternalLink className="h-4 w-4 text-green-600 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
              </button>
            ))}
          </div>
        </div>
      )}

      {uploadResults.errors.length > 0 && (
        <div className="p-4 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <AlertCircle className="h-5 w-5 text-red-600" />
            <h3 className="font-medium text-red-900 dark:text-red-200">
              Failed to Upload ({uploadResults.errors.length})
            </h3>
          </div>
          <div className="space-y-2">
            {uploadResults.errors.map((error, idx) => (
              <div key={idx} className="text-sm text-red-800 dark:text-red-200">
                <div className="font-medium">{error.filename}</div>
                <div className="text-xs text-red-700 dark:text-red-300">{error.error}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
